<template>
  <el-dialog :visible.sync="showPopup" width="400px" :title="`${isGaving ? '赠送' : ''}订单详情`" :show-close="false" center class="pay-dialog">
    <div class="dialog-container" v-loading="checkLoading" element-loading-text="正在校验">
      <div class="pay_title">订单内容</div>
      <!-- 万象下单 -->
      <template v-if="dialogType === 'wanxiang' || dialogType === 'vip' || dialogType === 'article'">
        <div class="pay-items-wrap">
          <div class="pay_projects" v-if="orderItems.length">
            <div
              class="pay_project"
              :class="{ checked: orderCheckItem === i }"
              v-for="(item, i) in orderItems"
              :key="i"
              @click.stop="orderCheckItem = i"
            >
              <div>
                <div class="project_title">{{ item.title }}</div>
                <div class="project-bottom-wrap">
                  <div class="project_type point" v-for="(cont, j) in item.content" :key="`cont_${j}`">
                    <span class="project_name">{{ cont.title }}</span>
                    <span class="project_period" v-if="item.period && !isGaving">有效期至:{{ item.period }}</span>
                  </div>
                </div>
              </div>
              <!-- 旧版本使用checkbox -->
              <!-- 4.2.9之后 展示原价 -->
              <span class="yixi-checkbox-wrap">
                <span class="old_price">{{ item.oldPrice }} 元</span>
                <span class="yixi-checkbox" :class="{ checked: orderCheckItem === i }"></span>
              </span>
            </div>
          </div>
        </div>
      </template>
      <!-- 万象下单END -->
      <!-- 现场下单 -->
      <template v-if="dialogType === 'activity'">
        <div class="activity-screenings-wrap">
          <div class="screening-main-title">{{ activityOrder.pay_title }}</div>
          <div class="screening-item point" v-for="screen in activityOrder.screenings" :key="screen.id">
            <div class="screening-item--left">
              <span>{{ screen.name }}</span>
              <span class="screening_tickets"> 剩余{{ screen.stock_surplus }}</span>
            </div>
            <el-input-number size="mini" v-model.trim="activityBuyNumbers[screen.id]" :min="0" :max="screen.pay_num"></el-input-number>
          </div>
        </div>
      </template>
      <!-- 现场下单END -->
      <!-- 含邀请码、优惠码 discount:折扣-->
      <template v-if="dialogType === 'wanxiang' || dialogType === 'vip' || dialogType === 'article'">
        <div class="discount-ipts-bl" v-show="showInviteCode || showDiscountCode">
          <!-- <div class="input-wrap" v-show="showInviteCode">
            <span class="label">邀请码</span>
            <input type="text" placeholder="请输入邀请码" @blur="checkInviteCode(true)" v-model="inviteCode" />
          </div> -->
          <div class="input-wrap" v-show="showDiscountCode">
            <span class="label">优惠码</span>
            <input type="text" placeholder="请输入优惠码" @blur="checkDiscountCode(true)" v-model="discountCode" />
          </div>
        </div>
      </template>
      <div class="pay_amount">
        <span class="pay_amount--label">合计</span>
        <span class="pay_amount--value">{{ payAmount }} 元</span>
      </div>
      <!-- 收货信息 -->
      <div class="consignee-info-bl" v-if="isNeedAddress">
        <div class="consignee-main-title">
          <span class="text">收货信息</span>
          <span class="tips">
            （点击对应信息即可修改）
          </span>
        </div>
        <div class="consignee-add-btn" v-if="!consignee.name" @click="consigneePopup = true">
          点击添加收货人信息
          <i class="iconfont iconring-add"></i>
        </div>
        <div class="consignee-info" v-else @click="showConsigneePopup">
          <div class="consignee-info-user-info">
            <!-- <span class="label">收货人信息</span> -->
            <span class="value">{{ consignee.name }} {{ consignee.mobile }}</span>
          </div>
          <div class="consignee-info-detail-address">
            <span class="consignee-info-detail-address--text">
              {{ consignee.addressStr }}
            </span>
          </div>
        </div>
      </div>
      <!-- 收货信息END -->
      <div class="pay_title">支付方式</div>
      <div class="pay_ways">
        <div class="pay_way" v-for="way in payWays" :key="way.type" @click="payConfirm(way.type)">
          <i class="iconfont logo" :class="way.icon" :style="{ color: way.color }"></i>
          <span class="way_name">{{ way.name }}</span>
          <span class="iconfont iconarrow_right arrow"></span>
          <!-- 4.2.9需求 删除支付方式checkbox -->
          <!-- <span class="yixi-checkbox" :class="{ checked: payWayCheck === way.type }"></span> -->
        </div>
        <div class="pay_tips">
          确定支付既表示您已阅读
          <span class="vip_book" @click="openAgreement">
            {{ dialogType === 'activity' ? '《用户协议》' : '《会员手册》' }}
          </span>
        </div>
      </div>
      <!-- 4.2.9需求 删除确认支付按钮 -->
      <!-- <div class="pay-actions-bl">
        <div class="pay_btn" @click="payConfirm" :class="{ disabled: payAmount <= 0 }">确认支付</div>
      </div> -->
      <!-- 微信二维码支付弹框 -->
      <div class="weixin_qrcode-popup" v-show="wexinQRCodePopup">
        <transition name="el-zoom-in-bottom">
          <div class="popup-container" v-show="wexinQRCodePopup">
            <div class="qrcode-bl">
              <img :src="wexinQRCodeUrl" />
              <div class="qrcode-tips">使用微信扫码支付</div>
            </div>
            <div class="qrcode-actions-bl">
              <div class="close_btn" @click="closeWeChatQRCodeDialog">关闭</div>
              <div class="query_res_btn" @click="showPayResultDialog">手动查询</div>
            </div>
          </div>
        </transition>
      </div>
      <!-- 微信二维码支付弹框END -->
      <!-- 收货人地址填写弹窗 -->
      <div class="consignee-popup" v-show="consigneePopup" @click="consigneePopup = false">
        <transition name="el-zoom-in-bottom">
          <div class="popup-container" v-show="consigneePopup" @click.stop>
            <div class="popup-title">收货人信息</div>
            <div class="consignee-form">
              <div class="consignee-form-item">
                <span class="label">收货人姓名：</span>
                <el-input v-model.trim="consigneeForm.name" placeholder="请输入姓名"></el-input>
              </div>
              <div class="consignee-form-item">
                <span class="label">手机号：</span>
                <el-input
                  v-model.trim="consigneeForm.mobile"
                  placeholder="请输入手机号"
                  @input="consigneeForm.mobile = consigneeForm.mobile.replace(/[^\d]/g, '')"
                  @blur="checkMobile"
                  maxlength="11"
                ></el-input>
              </div>
              <div class="consignee-form-item region">
                <span class="label">地址：</span>
                <span class="region-wrap">
                  <span class="region-text" :class="{ empty: !consigneePopupRegionStr }">{{ consigneePopupRegionStr || '请选择' }}</span>
                </span>
                <el-cascader size="large" :options="consigneeRegionOptions" v-model.trim="consigneeForm.region"> </el-cascader>
              </div>
              <div class="consignee-form-item">
                <span class="label">详细地址：</span>
                <el-input type="textarea" autosize v-model.trim="consigneeForm.address" placeholder="请输入详细地址"></el-input>
              </div>
            </div>
            <div class="popup-actions-bl">
              <div class="save_btn" :class="{ disabled: disableConsigneeSaveBtn }" @click="consigneeSubmit">保存</div>
            </div>
          </div>
        </transition>
      </div>
      <!-- 收货人地址填写弹窗END -->
    </div>
  </el-dialog>
</template>

<script>
import requestApi from '@/service';
import QRCode from 'qrcode';
import { regionData, CodeToText, TextToCode } from 'element-china-area-data';
import { InputNumber, Dialog, Cascader, Input } from 'element-ui';

export default {
  components: {
    [Dialog.name]: Dialog,
    [InputNumber.name]: InputNumber,
    [Cascader.name]: Cascader,
    [Input.name]: Input,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    dialogType: {
      type: String,
      default: 'wanxiang',
    },
  },
  data() {
    const getRegionData = () => {
      const filterData = ['710000', '810000', '820000']; // 不支持邮寄台湾、香港、澳门
      return regionData.filter(item => {
        return !filterData.includes(item.value);
      });
    };
    const consigneeRegionOptions = getRegionData();
    return {
      // 订单弹窗
      showPopup: false,
      payWays: [
        { icon: 'iconwxpay', name: '微信支付', type: 'WECHATPAY', color: '#53c51a' },
        { icon: 'iconalipay', name: '支付宝支付', type: 'ALIPAY', color: '#0679fe' },
      ],
      // 万象
      orderItems: [], // 万象支付项目
      orderCheckItem: 0, // 万象 购买项目 默认选中
      // 现场
      activityBuyNumbers: {}, // 现场购票数量
      activityOrder: {}, // 现场订单信息
      // 支付
      // payWayCheck: 'ALIPAY', // 购买方式 默认选中
      wexinQRCodePopup: false, // 控制微信二维码显示隐藏
      wexinQRCodeUrl: '', // 微信二维码url
      consignee: {},
      consigneePopup: false, // 收货人信息填写弹窗
      consigneeRegionOptions, // 收件人地址省市区选项
      consigneeForm: {
        region: [],
        name: '',
        mobile: '',
        address: '',
      },
      inviteCode: '', // 邀请码,
      discountCode: '', // 优惠码
      payAmount: 0,
      isGaving: false,
      checkLoading: false,
    };
  },
  model: {
    prop: 'show',
  },
  computed: {
    disableConsigneeSaveBtn() {
      let flag = false;
      const keys = Object.keys(this.consigneeForm);
      for (const key of keys) {
        if (!this.consigneeForm[key] || (key === 'region' && !this.consigneeForm[key].length)) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    /**
     * @description: 显示邀请码
     */
    showInviteCode() {
      return this.orderItems[this.orderCheckItem] && this.orderItems[this.orderCheckItem].isUseInviteCode;
    },
    /**
     * @description: 显示优惠码
     */
    showDiscountCode() {
      return this.orderItems[this.orderCheckItem] && this.orderItems[this.orderCheckItem].isUseDiscountCode;
    },
    /**
     * @description: 会员需判断，实物、实物课程则需要
     */
    isNeedAddress() {
      return this.orderItems[this.orderCheckItem] && this.orderItems[this.orderCheckItem].needAddress && !this.isGaving;
    },
    consigneePopupRegionStr() {
      const region = this.consigneeForm.region;
      const province = CodeToText[region[0]];
      const city = CodeToText[region[1]];
      const district = CodeToText[region[2]];
      return province ? `${province || ''} ${city || ''} ${district || ''}` : '';
    },
  },
  watch: {
    async show(val) {
      if (val) {
        this.initDialog();
        if (this.dialogType === 'wanxiang' || this.dialogType === 'vip' || this.dialogType === 'article') {
          await this.getWanXiangOrderData();
          this.setPayAmount();
        } else if (this.dialogType === 'activity') {
          await this.getActivityOrderData();
          this.setPayAmount();
        }
      }
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },
    orderCheckItem() {
      this.setPayAmount();
    },
    inviteCode() {
      this.checkInviteCode();
    },
    discountCode() {
      this.checkDiscountCode();
    },
  },
  beforeDestroy() {
    this.stopQueryOrderStatusTimer();
  },
  methods: {
    initDialog() {
      Object.assign(this.$data, this.$options.data());
      this.isRealDiscountCode = false;
      this.isRealInviteCode = false;
      this.isGaving = this.options.isGaving;
    },
    // 现场获取下单数据
    getActivityOrderData() {
      return requestApi(`/v3/api/h5/activity/${this.options.activityId}/screening/`).then(res => {
        this.activityOrder = res;
        const obj = {};
        res.screenings.forEach(item => {
          obj[item.id] = item.pay_num > 0 ? 1 : 0;
        });
        this.activityBuyNumbers = obj;
      });
    },
    // 万象获取下单数据
    getWanXiangOrderData() {
      const params = {};
      if (this.dialogType === 'wanxiang' || this.dialogType === 'article' || this.isGaving) {
        Object.assign(params, {
          wanxiang_id: this.options.wanxiangId,
        });
      }
      return requestApi('/v3/api/h5/wanxiang/settlement/', params).then(res => {
        this.orderItems = this.handleOrderData(res);
        // 是否可购买实物
        if (res.base && res.base.is_pay_material) {
          this.getConsigneeInfo();
        }
      });
    },
    handleOrderData({ course, info, article, base }) {
      // 非常难受的数据 处理一下
      const orderItems = [];
      let articleItem;
      let articleClassItem;
      let singleItem;
      let vipItem;
      if (info) {
        vipItem = {
          type: 'vip',
          title: info.title,
          content: [...info.conntent],
          period: info.next_end_time,
          oldPrice: info.member_price,
          price: info.member_price, // 会员现价
          discountPrice: info.member_discount_code_price, //会员折扣价格
          isUseInviteCode: true, // 邀请码
          isUseDiscountCode: true, // 优惠码
          needAddress: info.is_need_address,
        };
      }
      if (article) {
        if (base.is_pay_single_material) {
          articleItem = {
            type: 'article',
            title: base.title,
            content: [{ title: article.article_name }],
            oldPrice: article.article_price, // 原价
            price: article.article_discount_price, // 当前价格
            discountPrice: article.article_discount_code_price, // 折扣价格
            isUseInviteCode: article.article_is_use_invite_code, // 邀请码
            isUseDiscountCode: article.article_is_use_discount_code, // 优惠码
            needAddress: true,
          };
        }
        if (base.is_pay_material) {
          articleClassItem = {
            type: 'article_class',
            title: base.title,
            content: [{ title: base.wanxiang_name }, { title: article.article_name }],
            // 实话我tm也不知道为啥赠送就得是这个价格……无语惨了
            // oldPrice: this.isGaving ? article.comprehensive_discount_price : article.comprehensive_price, // 原价
            oldPrice: article.comprehensive_price, // 原价
            price: article.comprehensive_discount_price, // 当前价格
            discountPrice: article.comprehensive_discount_code_price, // 折扣价格
            isUseInviteCode: article.comprehensive_is_use_invite_code, // 邀请码
            isUseDiscountCode: article.comprehensive_is_use_discount_code, // 优惠码
            needAddress: true,
          };
        }
      } else if (base && base.is_single_buy && course) {
        singleItem = {
          type: 'single_class',
          title: course.title,
          content: [...course.content],
          oldPrice: course.course_price, // 原价
          price: course.total_price, // 当前价格
          discountPrice: course.course_discount_code_price, // 折扣价格
          isUseInviteCode: course.course_is_use_invite_code, // 邀请码
          isUseDiscountCode: course.course_is_use_discount_code, // 优惠码
          needAddress: false,
        };
      }
      if (this.isGaving) {
        orderItems.push(vipItem);
        if (base) {
          if (base.is_pay_material && articleClassItem) {
            orderItems.push(articleClassItem);
          } else if (base.is_single_buy && singleItem) {
            orderItems.push(singleItem);
          }
        }
      } else {
        // 实物 当前用户为会员 并且 当前课程为实物课程时 用户可购买实物 故只展示实物购买信息
        if (this.dialogType === 'article' && articleItem) {
          orderItems.push(articleItem);
        } else {
          // 会员默认展示 邀请码 优惠码
          orderItems.push(vipItem);
          if (this.dialogType === 'wanxiang') {
            if (base && base.is_single_buy === 1 && course) {
              // 单课
              orderItems.push(singleItem);
            } else if (article) {
              // 实物课程
              orderItems.push(articleClassItem);
            }
          }
        }
      }
      return orderItems;
    },
    closePayPopup() {
      this.showPopup = false;
    },
    /**
     * @description: 确认支付
     */
    payConfirm(payWay) {
      if (this.payAmount <= 0) return;
      this.payWayCheck = payWay;
      this.placeOrder().then(res => {
        // 说明是微信
        if (this.payWayCheck === 'WECHATPAY' && typeof res === 'object') {
          this.showWeChatQRCode(res);
        }
      });
    },
    showWeChatQRCode(res) {
      // 微信支付 显示二维码
      const qrUrl = res.charge && res.charge.code_url;
      if (qrUrl) {
        // 二维码生成
        QRCode.toDataURL(res.charge && res.charge.code_url, {
          type: 'image/jpeg',
          quality: 1,
          margin: 1,
        })
          .then(url => {
            this.orderId = this.getOrderId(res);
            this.startQueryOrderStatusTimer(this.orderId);
            this.wexinQRCodeUrl = url;
            this.wexinQRCodePopup = true;
          })
          .catch(err => {
            console.error('generate qrcode error =========> ', err);
          });
      } else {
        console.error('no wechat qrcode =========> ');
      }
    },
    // 下单
    placeOrder() {
      return new Promise((resolve, reject) => {
        if (this.checkSubmitConditions()) {
          const params = this.handleOrderParams();
          requestApi(this.getPlaceOrderUrl(), params, 'POST').then(res => {
            if (res) {
              if (this.payWayCheck === 'ALIPAY') {
                // 支付宝支付 跳转对应支付页面
                window.location.href = res.charge.return_url;
                resolve(true);
              } else if (this.payWayCheck === 'WECHATPAY') {
                resolve(res);
              }
            } else {
              reject();
            }
          });
        } else {
          reject();
        }
      });
    },
    /**
     * @description: 获取下单接口地址
     */
    getPlaceOrderUrl() {
      let url = '';
      switch (this.getOrderType()) {
        // 现场
        case 'activity':
          url = '/v3/api/h5/order/activity/';
          break;
        // 会员
        case 'vip':
          url = '/v3/api/h5/order/wanxiang/';
          break;
        // 实物课程、实物
        case 'article_class':
        case 'article':
          url = '/v3/api/h5/order/article/wanxiang/';
          break;
        // 单课
        case 'single_class':
          url = '/v3/api/h5/order/single/wanxiang/';
          break;
        default:
          break;
      }
      return url;
    },
    /**
     * @description: 验证支付条件
     * 1、判断是否有输入优惠码、邀请码 有则判断是否正确
     * 2、若含实物（课程、会员）则需校验用户是否输入地址
     */
    checkSubmitConditions() {
      if (this.showInviteCode && this.inviteCode && !this.isRealInviteCode) {
        this.$message.error('请输入正确的邀请码');
        return false;
      } else if (this.showDiscountCode && this.discountCode && !this.isRealDiscountCode) {
        this.$message.error('请输入正确的优惠码');
        return false;
      } else if (this.isNeedAddress && !this.consignee.id) {
        this.$message.error('请填写您的收货地址');
        return false;
      }
      return true;
    },
    // 下单参数
    handleOrderParams() {
      const orderType = this.getOrderType();
      const channel = this.payWayCheck === 'ALIPAY' ? 'ali_pc' : 'wx_pc'; // 只有微信支付和支付宝支付
      let redirect_url = null;
      if (this.payWayCheck === 'ALIPAY') {
        const queryStr = encodeURIComponent(JSON.stringify({ ...this.$route.query, orderType: this.getOrderType() }));
        const name = encodeURIComponent(this.$route.name);
        redirect_url = `${window.location.origin}/#/pay/middle?name=${name}&str=${queryStr}`;
      }
      // 2020/11/28 优惠码校验 增加类型判断
      let check_type = null;
      if (orderType === 'vip') {
        check_type = 0;
      } else if (orderType !== 'activity') {
        check_type = 1;
      }
      const params = {
        channel,
        redirect_url,
        wanxiang_id: this.options.wanxiangId || null,
        screenings_objs: orderType === 'activity' ? this.getActivityScreeningsObj() : null,
        check_type, // 若为会员时
      };
      // 只有 实物、实物课程、is_need_address 会员 才需要地址 赠送不需要
      if (!this.isGaving && this.isNeedAddress) {
        Object.assign(params, {
          address_id: this.consignee.id,
        });
      }
      // 邀请码
      if (this.showInviteCode && this.isRealInviteCode) {
        params.invitecode = this.inviteCode;
      }
      // 优惠码
      if (this.showDiscountCode && this.isRealDiscountCode) {
        params.discountcode = this.discountCode;
      }
      // 赠送 判断
      if (this.isGaving) {
        switch (orderType) {
          case 'article':
          case 'article_class':
            params.order_article_type = 1;
            break;
          case 'vip':
          case 'single_class':
            params.order_type = 1;
            break;
          default:
            break;
        }
      }
      // 实物课程 实物 传递order_type order_type(0实物课程、1实物)
      if (orderType === 'article') {
        params.order_type = 1;
      }
      if (orderType === 'article_class') {
        params.order_type = 0;
      }
      return params;
    },
    /**
     * @description: 获取当前选择的订单类型
     */
    getOrderType() {
      let orderType = '';
      if (this.dialogType === 'activity') {
        orderType = 'activity';
      } else if (this.dialogType === 'wanxiang' || this.dialogType === 'vip' || this.dialogType === 'article') {
        // 万象或会员
        const orderItem = this.orderItems[this.orderCheckItem];
        orderType = orderItem.type;
      }
      return orderType;
    },
    /**
     * @description: 获取结果值当中的orderId
     */
    getOrderId(res) {
      let orderId = '';
      const orderType = this.getOrderType();
      switch (orderType) {
        case 'activity': // 现场
          orderId = res.activity_order.id;
          break;
        case 'vip': // 会员
          orderId = res.wanxiang_member_order.id;
          break;
        case 'article': // 实物
        case 'article_class': // 实物课程
          orderId = res.wanxiang_article_order.id;
          break;
        case 'single_class': // 单课
          orderId = res.wanxiang_single_order.id;
          break;
        default:
          break;
      }
      return orderId;
    },
    /**
     * @description: 获取现场已选场次和票数
     */
    getActivityScreeningsObj() {
      const list = [];
      Object.keys(this.activityBuyNumbers).forEach(key => {
        list.push({
          id: key,
          num: this.activityBuyNumbers[key],
        });
      });
      return list;
    },
    /**
     * @description: 若为微信支付 轮询支付结果
     */
    startQueryOrderStatusTimer(orderId = this.orderId) {
      if (this.queryOrderStatusTimer) {
        this.stopQueryOrderStatusTimer();
      }
      this.queryOrderStatusTimer = setTimeout(() => {
        this.queryOrderStatusTimer = null;
        this.queryOrderStatus(orderId).then(order => {
          if (+order.status !== 1) {
            this.startQueryOrderStatusTimer(this.orderId);
          } else {
            this.showPayResultDialog();
          }
        });
      }, 2000);
    },
    /**
     * @description: 停止微信支付轮询
     */
    stopQueryOrderStatusTimer() {
      clearTimeout(this.queryOrderStatusTimer);
    },
    /**
     * @description: 查询订单状态
     */
    queryOrderStatus(orderId = this.orderId) {
      let url;
      switch (this.getOrderType()) {
        case 'vip':
          url = `/v3/api/h5/order/wanxiang/member/${orderId}`;
          break;
        case 'single_class':
          url = `/v3/api/h5/order/wanxiang/single/${orderId}`;
          break;
        case 'article':
        case 'article_class':
          url = `/v3/api/h5/order/wanxiang/article/${orderId}`;
          break;
        case 'activity':
          url = `/v3/api/h5/order/${orderId}`;
          break;
        default:
          break;
      }
      return new Promise(resolve => {
        requestApi(url).then(({ order }) => {
          resolve(order);
        });
      });
    },
    closeWeChatQRCodeDialog() {
      this.wexinQRCodePopup = false;
      this.stopQueryOrderStatusTimer();
    },
    /**
     * @description: 手动查询 支付结果
     */
    showPayResultDialog() {
      this.showPopup = false;
      this.stopQueryOrderStatusTimer();
      this.$emit('showPayResult', this.orderId, this.getOrderType());
    },
    handleConsigneeParams() {
      const { region, mobile, name, address } = this.consigneeForm;
      const params = {
        province: CodeToText[region[0]],
        city: CodeToText[region[1]],
        district: CodeToText[region[2]],
        mobile,
        name,
        address,
      };
      return params;
    },
    /**
     * @description: 获取用户的收货信息
     */
    getConsigneeInfo() {
      requestApi('/v3/api/h5/address/').then(res => {
        this.setConsignee(res);
      });
    },
    consigneeSubmit() {
      if (this.disableConsigneeSaveBtn || !this.checkMobile()) return;
      const params = this.handleConsigneeParams();
      requestApi('/v3/api/h5/address/', params, 'PUT').then(res => {
        this.consigneePopup = false;
        this.setConsignee(res);
      });
    },
    setConsignee(data) {
      this.consignee = { ...data, addressStr: `${data.province}${data.city}${data.district} ${data.address}`, id: data.address_id };
    },
    checkMobile() {
      const mobile = this.consigneeForm.mobile;
      const res = mobile.length === 11 && /^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(mobile);
      if (!res) {
        this.$message.error('请输入正确的手机号码');
      }
      return res;
    },
    /**
     * @description: 校验邀请码
     */
    checkInviteCode(printMsg) {
      if (!this.inviteCode) {
        this.isRealInviteCode = false;
        this.setPayAmount();
        return;
      }
      if (this._riverClosure('checkInviteCode', 500)) {
        this.checkLoading = true;
        requestApi(
          '/v3/api/h5/consume/invitecode/check/',
          {
            code: this.inviteCode,
          },
          'GET',
          {},
          { printMsg: false }
        ).then(
          () => {
            this.checkLoading = false;
            this.isRealInviteCode = true;
            this.setPayAmount();
          },
          err => {
            this.checkLoading = false;
            this.isRealInviteCode = false;
            this.setPayAmount();
            if (printMsg) {
              this.inviteCode = '';
              this.$message.error(err.error_msg);
            }
          }
        );
      }
    },
    /**
     * @description: 校验优惠码
     */
    checkDiscountCode(printMsg) {
      if (!this.discountCode) {
        this.isRealDiscountCode = false;
        this.setPayAmount();
        return;
      }
      if (this._riverClosure('checkDiscountCode', 500)) {
        this.checkLoading = true;
        this.checkDiscountCodeTimer = null;
        // 2020/11/28 优惠码校验 增加类型判断
        const orderType = this.getOrderType();
        let check_type = null;
        if (orderType === 'vip') {
          check_type = 0; // 会员
        } else if (orderType !== 'activity') {
          check_type = 1; // 万象
        }
        requestApi(
          '/v3/api/h5/consume/discountcode/check/',
          {
            code: this.discountCode,
            check_type,
            wanxiang_id: check_type ? this.options.wanxiangId : null,
          },
          'GET',
          {},
          { printMsg: false }
        ).then(
          () => {
            this.checkLoading = false;
            this.isRealDiscountCode = true;
            this.setPayAmount();
          },
          err => {
            this.checkLoading = false;
            this.isRealDiscountCode = false;
            this.setPayAmount();
            if (printMsg) {
              this.discountCode = '';
              this.$message.error(err.error_msg);
            }
          }
        );
      }
    },
    // 显示收件人信息
    showConsigneePopup() {
      const { name, mobile, address, province, city, district } = this.consignee;
      const provinceId = TextToCode[province] ? TextToCode[province].code : '';
      let cityId = '';
      let districtId = '';
      // 因为接口只存了汉字 没有id h5的vant控件和element控件 存储文字不一致 故只能用此方法兼容
      const citys = ['北京市', '天津市', '上海市', '重庆市'];
      if (city === province && citys.includes(province)) {
        cityId = TextToCode[province]['市辖区'] ? TextToCode[province]['市辖区'].code : '';
        districtId = TextToCode[province]['市辖区'][district] ? TextToCode[province]['市辖区'][district].code : '';
      } else {
        cityId = TextToCode[province][city] ? TextToCode[province][city].code : '';
        districtId = TextToCode[province][city][district] ? TextToCode[province][city][district].code : '';
      }
      let region = [];
      // 兼容奇葩的APP地址 哎……
      if (provinceId) {
        region = [provinceId, cityId, districtId];
      }
      this.consigneeForm = { name, mobile, address, region };
      this.consigneePopup = true;
    },
    // 合计
    setPayAmount() {
      let amount = 0;
      switch (this.dialogType) {
        case 'wanxiang':
        case 'vip':
        case 'article':
          amount = this.wanxiangAmount();
          break;
        case 'activity': // 现场购票
          amount = this.activityAmount();
          break;
        default:
          break;
      }
      this.payAmount = amount;
    },
    // 万象会员、实物、实物课程、单课 合计价格计算
    wanxiangAmount() {
      let amount = 0;
      // 当前已勾选的购买项
      const temp = this.orderItems[this.orderCheckItem];
      if (temp) {
        // 判断是否有有效优惠码 有则展示折扣价
        amount = this.isRealDiscountCode && this.showDiscountCode ? temp.discountPrice : temp.price;
      }
      return amount;
    },
    // 现场购票 合计价格计算
    activityAmount() {
      let amount = 0;
      if (this.activityOrder.screenings && this.activityOrder.screenings.length) {
        this.activityOrder.screenings.forEach(screen => {
          if (this.activityBuyNumbers[screen.id]) {
            amount += this.activityBuyNumbers[screen.id] * screen.price || 0;
          }
        });
      }
      return amount;
    },
    openAgreement() {
      let path = '/about/memberHandbook';
      if (this.dialogType === 'activity') {
        path = '/about/userAgreement';
      }
      const routeData = this.$router.resolve({
        path,
        query: {
          type: 'more',
        },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-dialog {
  ::v-deep.el-dialog__header {
    text-align: center;
    padding: 25px 0 5px;
  }
  ::v-deep.el-dialog__body {
    padding: 0;
    color: $C3;
  }
  .pay_title {
    font-family: HYXinRenWenSongW;
    font-size: 12px;
    padding: 15px 20px 10px;
    font-weight: bold;
  }
}
.pay-dialog {
  ::v-deep.el-dialog__title {
    font-family: HYXinRenWenSongW;
    font-size: 15px;
  }
  .pay_projects {
    .pay_project {
      color: $A1;
      line-height: 1.2;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      transition: color 0.3s ease-in;
      padding: 10px 20px;
      background: $C15;
      .project_title {
        font-size: 18px;
        font-family: HYXinRenWenSongW;
        margin-bottom: 10px;
        letter-spacing: 2px;
      }
      .project_type {
        font-size: 12px;
        width: 100%;
        padding: 5px 0px 5px 10px;
        font-family: HYXinRenWenSongW;
        position: relative;
        .project_name {
          font-size: 12px;
          line-height: 16px;
        }
        .project_period {
          color: $C13;
          line-height: 14px;
          font-size: 12px;
          letter-spacing: 1.3px;
          margin-left: 12px;
        }
      }
      &.checked {
        color: $C3;
      }
      .yixi-checkbox-wrap {
        display: inline-flex;
        align-items: center;
        .old_price {
          margin-right: 20px;
          font-size: 14px;
          line-height: 20px;
        }
      }
      &:first-child {
        padding-top: 20px;
        border-bottom: 1px solid #f2f2f2;
      }
      &:last-child {
        padding-bottom: 20px;
      }
    }
  }
  .pay_amount {
    border-top: 1px dashed #e0e0e0;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding: 20px;
    background: $C15;
    &--value {
      font-weight: bold;
      letter-spacing: 2px;
      color: $C14;
    }
  }
  .activity-screenings-wrap {
    padding: 0 20px;
    background-color: $C15;
  }

  .activity-screenings-wrap {
    padding-bottom: 20px;
    .screening-main-title {
      padding: 20px 0;
      font-size: 14px;
      font-family: HYXinRenWenSongW;
    }
    .screening-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 10px;
      margin-bottom: 2px;
      .screening-item--left {
        font-size: 14px;
        font-family: HYXinRenWenSongW;
        .screening_tickets {
          font-size: 12px;
          color: $C13;
          margin-left: 5px;
        }
      }
    }
    .el-input-number {
      display: inline-flex;
      align-items: center;
      height: 20px;
      line-height: 1;
      width: auto;
      border: 1px solid #e0e0eb;
      ::v-deep.el-input-number__decrease,
      ::v-deep.el-input-number__increase {
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 0;
        background: $C1;
        top: 0;
        &:hover {
          color: $C3;
        }
      }
      ::v-deep.el-input-number__decrease {
        border-right: 1px solid #e0e0eb;
        left: 0;
      }
      ::v-deep.el-input-number__increase {
        border-left: 1px solid #e0e0eb;
        right: 0;
      }
      ::v-deep.el-input__inner {
        width: 60px;
        padding: 0 20px;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        border-radius: 0;
        border: none;
      }
    }
  }
  .pay_ways {
    .pay_way {
      display: flex;
      align-items: center;
      color: $C3;
      transition: color 0.3s ease-in;
      background: $C15;
      padding: 15px 20px;
      cursor: pointer;
      &:first-child {
        margin-bottom: 1px;
      }
      .iconfont {
        &.logo {
          font-size: 18px;
        }
        &.arrow {
          font-size: 14px;
        }
      }
      .way_name {
        flex: 1;
        margin-left: 18px;
      }
    }
  }
  .pay_tips {
    font-size: 12px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    color: $C13;
    cursor: pointer;
    .vip_book {
      color: #006eff;
    }
  }
  .pay-actions-bl {
    text-align: center;
    margin-top: 20px;
    .pay_btn {
      display: inline-block;
      width: 130px;
      height: 34px;
      line-height: 34px;
      background: $C2;
      color: $C1;
      text-align: center;
      cursor: pointer;
      font-family: HYXinRenWenSongW;
      border: 1px solid $C2;
      transition: all 0.3s ease-in-out;
      &.disabled {
        border-color: $C3;
        background: $C1;
        color: $C3;
        cursor: default;
      }
    }
  }
  .weixin_qrcode-popup {
    .qrcode-bl {
      margin-bottom: 20px;
      & > img {
        width: 200px;
        height: 200px;
        max-width: 100%;
      }
      .qrcode-tips {
        color: $C3;
        font-size: 16px;
        text-align: center;
      }
    }
    .qrcode-actions-bl {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .close_btn,
      .query_res_btn {
        width: 100px;
        height: 40px;
        line-height: 40px;
        font-family: HYXinRenWenSongW;
        text-align: center;
        cursor: pointer;
        border: 1px solid $C3;
      }
      .close_btn {
        color: $C1;
        background: $C3;
      }
      .query_res_btn {
        background: $C1;
        color: $C3;
      }
    }
  }
  .weixin_qrcode-popup,
  .consignee-popup {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: $A1;
    z-index: 999;
    .popup-container {
      background: $C1;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 20px 0 30px;
      z-index: 2;
      text-align: center;
    }
  }
  .consignee-popup {
    .popup-container {
      padding: 0 0 30px;
      width: 100%;
      box-sizing: border-box;
      .popup-title {
        padding: 20px 15px 10px;
        text-align: left;
        font-size: 12px;
        line-height: 14px;
        color: #4a4a4a;
        letter-spacing: 1px;
      }
      .consignee-form {
        &-item {
          background: $C15;
          display: flex;
          align-items: center;
          margin-bottom: 1px;
          padding: 5px 20px;
          .label {
            white-space: nowrap;
            color: $C13;
          }
          ::v-deep.el-input__inner,
          ::v-deep.el-textarea__inner {
            border: none;
            text-align: right;
            color: $C3;
            background: transparent;
          }
          ::v-deep.el-textarea__inner {
            resize: none;
          }
          &.region {
            position: relative;
            .region-wrap {
              flex: 1;
              text-align: right;
              display: inline-block;
              height: 100%;
              padding: 0 15px;
              .region-text {
                width: auto;
                display: inline-block;
                text-align: justify;
                &.empty {
                  color: #c1c4cb;
                }
              }
            }
            .el-cascader {
              position: absolute;
              right: 0;
              top: 0;
              width: 70%;
              opacity: 0;
            }
          }
        }
      }
      .popup-actions-bl {
        padding-top: 20px;
        .save_btn {
          transition: all 0.3s ease-in-out;
          display: inline-block;
          padding: 8px 50px;
          font-size: 14px;
          line-height: 16px;
          color: $C1;
          background: $C7;
          border-radius: 2px;
          border: 1px solid $C7;
          cursor: pointer;
          &.disabled {
            color: $C13;
            border-color: $C12;
            background: $C1;
          }
        }
      }
    }
  }
  .discount-ipts-bl {
    .input-wrap {
      height: 50px;
      font-size: 14px;
      display: flex;
      align-items: center;
      padding: 8px 20px;
      background: $C15;
      border-bottom: 1px solid #f2f2f2;
      box-sizing: border-box;
      .label {
        color: $C13;
      }
      & > input {
        flex: 1;
        display: inline-block;
        height: 100%;
        border: none;
        outline: none;
        color: $C3;
        text-align: right;
        background: transparent;
      }
      &:last-child {
        border: none;
      }
    }
  }
  .consignee-info-bl {
    .consignee-main-title {
      font-size: 12px;
      padding: 15px 20px 10px;
      display: flex;
      align-items: center;
      .text {
        font-family: HYXinRenWenSongW;
        line-height: 14px;
        letter-spacing: 1.3px;
      }
      .tips {
        line-height: 14px;
        color: $C13;
        letter-spacing: 1.3px;
        margin-left: 5px;
      }
    }
    .consignee-add-btn {
      padding: 25px 30px;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 1px;
      color: #4a4a4a;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: $C15;
      cursor: pointer;
      .iconfont {
        font-size: 16px;
        color: $C5;
        display: inline-block;
      }
    }
    .consignee-info {
      background: $C15;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 1.3px;
      color: #4a4a4a;
      padding: 15px 20px;
      &-user-info,
      &-detail-address {
        cursor: pointer;
      }
      &-detail-address {
        text-align: left;
        &--text {
          width: auto;
          display: inline-block;
          text-align: justify;
        }
      }
      &-user-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        .label {
          color: $C13;
        }
      }
    }
  }
}
</style>
